import React from 'react';
import cacheUtils from '../../utils/cacheUtils';

const CacheDebugPanel = () => {
  const [stats, setStats] = React.useState(null);
  const [visible, setVisible] = React.useState(false);

  const refreshStats = () => {
    setStats(cacheUtils.getStats());
  };

  React.useEffect(() => {
    if (visible) {
      refreshStats();
      const interval = setInterval(refreshStats, 2000);
      return () => clearInterval(interval);
    }
  }, [visible]);

  if (!visible) {
    return (
      <button
        onClick={() => setVisible(true)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          background: '#4ade80',
          color: 'white',
          border: 'none',
          padding: '10px',
          borderRadius: '5px',
          cursor: 'pointer',
          zIndex: 9999
        }}
      >
        🗑️ Cache
      </button>
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        background: 'white',
        border: '1px solid #ccc',
        borderRadius: '5px',
        padding: '15px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        zIndex: 9999,
        minWidth: '300px'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h4 style={{ margin: 0 }}>Cache Debug Panel</h4>
        <button onClick={() => setVisible(false)} style={{ background: 'none', border: 'none', fontSize: '16px', cursor: 'pointer' }}>
          ×
        </button>
      </div>
      
      {stats && (
        <div style={{ fontSize: '12px', marginBottom: '10px' }}>
          <p><strong>Cache Size:</strong> {stats.size} items</p>
          <p><strong>Keys:</strong></p>
          <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
            {stats.keys.map(key => (
              <li key={key} style={{ wordBreak: 'break-all' }}>{key}</li>
            ))}
          </ul>
        </div>
      )}
      
      <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
        <button onClick={() => { cacheUtils.clearAll(); refreshStats(); }} style={{ background: '#ef4444', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
          Clear All
        </button>
        <button onClick={() => { cacheUtils.clearContentType('subjects'); refreshStats(); }} style={{ background: '#f59e0b', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
          Clear Subjects
        </button>
        <button onClick={() => { cacheUtils.clearContentType('papers'); refreshStats(); }} style={{ background: '#f59e0b', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
          Clear Papers
        </button>
        <button onClick={() => { cacheUtils.clearContentType('videos'); refreshStats(); }} style={{ background: '#f59e0b', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
          Clear Videos
        </button>
        <button onClick={() => { cacheUtils.clearContentType('exams'); refreshStats(); }} style={{ background: '#f59e0b', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
          Clear Exams
        </button>
        <button onClick={refreshStats} style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '3px', cursor: 'pointer' }}>
          Refresh Stats
        </button>
      </div>
    </div>
  );
};

export default CacheDebugPanel;
